<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <v-layout row wrap>
          <v-flex xs12>
            <general></general>
          </v-flex>
          <v-flex xs12>
            <premium></premium>
          </v-flex>
          <v-flex xs12>
            <applicant></applicant>
          </v-flex>
          <v-flex xs12>
            <excess-stats></excess-stats>
          </v-flex>
          <v-flex xs12>
            <driver></driver>
          </v-flex>
          <v-flex xs12>
            <vehicle></vehicle>
          </v-flex>
          <v-flex xs12>
            <payment></payment>
          </v-flex>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="pt-3">
              <v-spacer></v-spacer>
              <v-btn color="error" :loading="quotation.saving" @click.prevent="doDecline">
                Decline
                <v-icon right dark>mdi-close</v-icon>
              </v-btn>
              <v-btn color="primary" :loading="quotation.saving" @click.prevent="doApprove">
                Approve
                <v-icon right dark>mdi-check</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg4 xs12 order-lg2 order-xs1>
        <quick-info query></quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Motor Quotation Details..." errorText="Failed to load Motor Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import { generalMotorForm } from '@/store/modules/agency/actions/quote'
import QuickInfo from '../query/QuickInfo'
import General from '../query/General'
import Vehicle from '../query/Vehicle'
import Applicant from '../query/Applicant'
import Driver from '../query/Driver'
import ExcessStats from '../query/ExcessStats'
import Premium from '../query/Premium'
import Payment from '../query/Payment'
import MessageMixin from '@/mixins/message'

export default {
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quotation() {
      return this.$store.state.agency.quotation
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('motorQuoteInit')
    },
    async doApprove() {
      const apiUrl = this.quotation.menu.approveRefProposal
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Proposal has been approved')

          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doDecline() {
      const apiUrl = this.quotation.menu.declineRefProposal
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Proposal has been declined')

          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Set query mode on lifeCycle component (to disable editing of sales oppo)
    this.toggleQuery(true)

    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    QuickInfo,
    General,
    Vehicle,
    Applicant,
    Driver,
    ExcessStats,
    Premium,
    Payment
  },
  mixins: [
    MessageMixin
  ],
  props: {
    toggleQuery: {
      type: Function,
      default: function (queryMode) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">

</style>
